import React from 'react';
import UserMenu from './UserMenu';

interface UtilityTopBarProps {
   showTitlebarInset: boolean;
   projectTitle?: string;
   menuRef: React.RefObject<HTMLDivElement>;
   menuOpen: boolean;
   onMenuToggle: () => void;
   onMenuClose: () => void;
   selectedProjectId: string | null;
   onExport: () => void;
   onImport: () => void;
   isImporting: boolean;
}

function UtilityTopBar({
   showTitlebarInset,
   projectTitle,
   menuRef,
   menuOpen,
   onMenuToggle,
   onMenuClose,
   selectedProjectId,
   onExport,
   onImport,
   isImporting,
}: UtilityTopBarProps) {
   const title = projectTitle?.trim();

   return (
      <div
         className={`relative flex flex-shrink-0 items-stretch border-b border-white/10 bg-midnight/95 ${
            showTitlebarInset ? 'h-12' : 'h-11'
         }`}
      >
         {title && (
            <div className="pointer-events-none absolute inset-x-40 bottom-2 flex h-8 items-center justify-center">
               <h1 className="max-w-full truncate text-center text-[13px] font-semibold leading-5 text-pearl/90">
                  {title}
               </h1>
            </div>
         )}
         <div className="no-drag w-32 flex-shrink-0" />
         <div className="draggable flex min-w-0 flex-1 items-end justify-end px-4 pb-2">
            <UserMenu
               menuRef={menuRef}
               menuOpen={menuOpen}
               onToggle={onMenuToggle}
               onClose={onMenuClose}
               selectedProjectId={selectedProjectId}
               onExport={onExport}
               onImport={onImport}
               isImporting={isImporting}
            />
         </div>
      </div>
   );
}

export default UtilityTopBar;
